// extracted by mini-css-extract-plugin
export var text = "_71-0";